// Local translations
export const T = {
  en_GB: {
    name: "Name",
    language: "Language",
    flow: "Flow",
    description: "Description",
    status: "Status",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    noTemplatesYet: "No PDF templates yet. Create your first template to get started.",
    deletePdfTemplate: "Delete PDF Template",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    clone: "Duplicate",
    cancel: "Cancel",
    error: "Error",
    ok: "OK",
    failedToDelete: "Failed to delete PDF template",
  },
  nb_NO: {
    name: "Navn",
    language: "Språk",
    flow: "Flyt",
    description: "Beskrivelse",
    status: "Status",
    created: "Opprettet",
    actions: "Handlinger",
    active: "Aktiv",
    inactive: "Inaktiv",
    noTemplatesYet: "Ingen PDF-maler ennå. Opprett din første mal for å komme i gang.",
    deletePdfTemplate: "Slett PDF-mal",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    clone: "Dupliser",
    cancel: "Avbryt",
    error: "Feil",
    ok: "OK",
    failedToDelete: "Kunne ikke slette PDF-mal",
  },
} as const;
